module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inbox"
  }, [_c('page-bar'), _vm._v(" "), _c('h3', {
    staticClass: "page-title"
  }, [_vm._v("\n\t\tCaixa de Entrada\n\t")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('sidebar-menu')], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('message-new')], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dbff3eda","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./sources/app/inbox/new-message/new-message.vue
// module id = 1114
// module chunks = 1